/* eslint-disable */
export default {
  currentCall: 'Huidige oproep',
  viewCalls: 'Oproep weergeven',
  view: 'Weergeven',
  incomingCall: '{numberOf} inkomende oproep',
  incomingCalls: '{numberOf} inkomende oproepen',
  callOnHold: '{numberOf} oproep in de wacht',
  callsOnHold: '{numberOf} oproepen in de wacht',
  otherDeviceCall: '{numberOf} oproep op andere apparaten',
  otherDeviceCalls: '{numberOf} oproepen op andere apparaten',
} as const;

// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"viewCalls"@#@ @source: @#@"View Calls"@#@
// @key: @#@"view"@#@ @source: @#@"View"@#@
// @key: @#@"incomingCall"@#@ @source: @#@"{numberOf} Incoming Call"@#@
// @key: @#@"incomingCalls"@#@ @source: @#@"{numberOf} Incoming Calls"@#@
// @key: @#@"callOnHold"@#@ @source: @#@"{numberOf} Call On Hold"@#@
// @key: @#@"callsOnHold"@#@ @source: @#@"{numberOf} Calls On Hold"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"{numberOf} Call on other devices"@#@
// @key: @#@"otherDeviceCalls"@#@ @source: @#@"{numberOf} Calls on other devices"@#@
